export function IcpFooter() {
  return (
    <div className='bg-background/95 supports-[backdrop-filter]:backdrop-blur-sm pointer-events-none fixed inset-x-0 bottom-0 z-40 flex justify-center border-t py-1.5'>
      <a
        href='https://beian.miit.gov.cn/'
        target='_blank'
        rel='noopener noreferrer'
        className='text-foreground pointer-events-auto text-sm font-medium hover:underline'
      >
        浙ICP备2025199164号
      </a>
    </div>
  )
}
